import { render, staticRenderFns } from "./edit-show.vue?vue&type=template&id=3a61770d&scoped=true"
import script from "./edit-show.vue?vue&type=script&lang=js"
export * from "./edit-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61770d",
  null
  
)

export default component.exports